import { render, staticRenderFns } from "./ProtelBlanket.vue?vue&type=template&id=6066db17&scoped=true&"
import script from "./ProtelBlanket.vue?vue&type=script&lang=js&"
export * from "./ProtelBlanket.vue?vue&type=script&lang=js&"
import style0 from "./ProtelBlanket.vue?vue&type=style&index=0&id=6066db17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6066db17",
  null
  
)

export default component.exports